import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_main/_project/upgrade/cancelled')({
  beforeLoad: () => {
    throw redirect({ to: '/upgrade' });
  },
});
